module.exports = __webpack_public_path__ + "img/360-matrum-old.cb460a72.jpg";